"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var makeBackground_1 = __importDefault(require("./makeBackground"));
var borderMap = {
    secondary: 0,
    nav: 1,
};
exports.default = (function (type, _a) {
    var _b = _a === void 0 ? {} : _a, hovered = _b.hovered, active = _b.active;
    return function (_a) {
        var theme = _a.theme, background = _a.background, brand = _a.brand;
        if (hovered && type === Object.keys(borderMap)[0]) {
            return ("border: 1px solid " + theme.palette.buttonBorderHover[0] + ";");
        }
        return ("border: 1px solid " + (type in borderMap && !brand
            ? theme.palette.buttonBorder[borderMap[type]]
            : (0, makeBackground_1.default)(type, { hovered: hovered, active: active })({ theme: theme, background: background, brand: brand })) + ";");
    };
});
